import { COLLECTION_NAME } from ".";
import { updateDocument } from "db/mutations";
import { put } from "db/api";

export const updatePlan = async (id, body) => {
  try {
    const response = await put("/update-plan/" + id, body);
    const data = await response.json();

    if (!response.ok) {
      console.error("Error en la función:", data.error);
      return;
    }

    // Actualizar el plan en la base de datos
    await updateDocument(COLLECTION_NAME, id, data);
  } catch (error) {
    console.error("Error inesperado:", error.message);
  }
};
